/**
 * API Documentation
 * API Documentation
 *
 * The version of the OpenAPI document: uk-cca-app-api 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AdminTerminationReasonDetails {
  reason:
    | 'SITE_CLOSURE_SCHEME'
    | 'NOT_SIGN_AGREEMENT'
    | 'TRANSFER_OF_OWNERSHIP'
    | 'DATA_NOT_PROVIDED'
    | 'FAILURE_TO_COMPLY'
    | 'FAILURE_TO_AGREE'
    | 'FAILURE_TO_PAY';
  explanation: string;
  relevantFiles?: string[];
}
